export const copy = {
  submitTicket: {
    subject: "Need Assistance",
  },
};
